module.exports = __webpack_public_path__ + "img/img45.4c449e0c.svg";